/**
 * Convierte un fragmento de HTML o texto a formato de lectura biónica,
 * envolviendo las letras guía en etiquetas <b class="b-h"> y el resto en <span class="b-w">.
 * Respeta todas las etiquetas HTML existentes sin alterarlas.
 */
export function toBionicHtml(html: string): string {
  if (!html) return "";
  
  let result = "";
  let i = 0;
  const len = html.length;
  let inTag = false;
  let currentText = "";

  const flushText = (text: string) => {
    // Busca secuencias de caracteres alfanuméricos y acentos en español
    return text.replace(/[A-Za-z0-9áéíóúÁÉÍÓÚñÑüÜ]+/g, (word) => {
      if (word.length === 0) return "";
      const wLen = word.length;
      let boldLen = 1;
      
      if (wLen <= 3) {
        boldLen = 1;
      } else if (wLen === 4) {
        boldLen = 2;
      } else {
        boldLen = Math.ceil(wLen * 0.4);
      }
      
      const boldPart = word.substring(0, boldLen);
      const restPart = word.substring(boldLen);
      return `<span class="b-w"><b class="b-h">${boldPart}</b>${restPart}</span>`;
    });
  };

  while (i < len) {
    const char = html[i];
    if (char === '<') {
      if (currentText) {
        result += flushText(currentText);
        currentText = "";
      }
      inTag = true;
      result += char;
    } else if (char === '>') {
      inTag = false;
      result += char;
    } else {
      if (inTag) {
        result += char;
      } else {
        currentText += char;
      }
    }
    i++;
  }

  if (currentText) {
    result += flushText(currentText);
  }

  return result;
}
